import { render, staticRenderFns } from "./CmgPointsHistory.vue?vue&type=template&id=a94fcf10&scoped=true&lang=pug&"
import script from "./cmg-points-history.ts?vue&type=script&lang=ts&"
export * from "./cmg-points-history.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPointsHistory.vue?vue&type=style&index=0&id=a94fcf10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94fcf10",
  null
  
)

export default component.exports